import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

// Vannmerke for testkontoer: bare ordet «TEST», svakt og skrått midt på skjermen.
// Det ligger over innholdet men slipper alle klikk gjennom, så det aldri er i veien.
export default function TestModeBanner() {
  const { userDoc } = useAuth();

  if (!userDoc?.isTestAccount) return null;

  return (
    <div style={styles.layer} aria-hidden="true" data-testid="test-watermark">
      <span style={styles.word}>TEST</span>
    </div>
  );
}

const styles = {
  layer: {
    position: 'fixed',
    inset: 0,
    zIndex: 3000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
    userSelect: 'none',
    overflow: 'hidden',
  },
  word: {
    fontSize: 'min(34vw, 260px)',
    fontWeight: 900,
    letterSpacing: '0.08em',
    lineHeight: 1,
    transform: 'rotate(-24deg)',
    color: 'rgba(128, 128, 128, 0.12)',
  },
};
